import { mapValues } from 'es-toolkit';
import { createSelector } from '@reduxjs/toolkit';

import { InstanceInfo } from '@paragon/production-app-utilities';

import { HeightCache, WidthCache } from '../ComponentGeometryCaches';
import { getProductionComponentInstancesByBundleGuid } from './getProductionComponentInstancesByBundleGuid';
import { getLoadedTrussesByAnalysisSetGuid } from './trusses';

export const getInstanceInfoByBundleGuid = createSelector(
  getProductionComponentInstancesByBundleGuid,
  getLoadedTrussesByAnalysisSetGuid,

  (productionComponentInstancesByBundleGuid, loadedTrussesByAnalysisSetGuid) =>
    mapValues(productionComponentInstancesByBundleGuid, (productionComponentInstancesForBundle) =>
      productionComponentInstancesForBundle.reduce((accumulator, instance) => {
        const truss = loadedTrussesByAnalysisSetGuid[instance.analysisSetGuid];
        if (!truss) return accumulator;
        const thickness = truss.numberOfPlies * truss.thickness;
        accumulator[instance.guid] = {
          name: truss.name,
          thickness,
          width: WidthCache.get(instance.analysisSetGuid, truss),
          height: HeightCache.get(instance.analysisSetGuid, truss),
          plies: truss.numberOfPlies,
          analysisSetGuid: instance.analysisSetGuid,
        };
        return accumulator;
      }, {} as InstanceInfo),
    ),
);
